// ════════════════════════════════════════════════════════════════════
// datePicker.js — make the whole <input type="date"> open the native picker.
// ════════════════════════════════════════════════════════════════════
// #15: make the WHOLE date field open the calendar (not just the tiny icon).
// Spread {...openPickerProps} onto any <input type="date"> to enable it.
// showPicker() is supported in all current browsers; we guard for older ones.
export const openDatePicker = (e) => {
  try { if (typeof e.currentTarget.showPicker === "function") e.currentTarget.showPicker(); } catch(_) {}
};
export const openPickerProps = { onClick: openDatePicker, onFocus: openDatePicker, style: { cursor: "pointer" } };
